<ng-template #Modal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
    <nb-card-header>
      {{ tt('product_add_product', '選擇商品種類') }}
    </nb-card-header>
    <nb-card-body class="staffInfoTemplate">
      <div class="row mx-0 mt-3">
        <input class="col" [(ngModel)]="query.searchKey" name="searchKey" type="text" nbInput fullWidth
          shape="rectangle" [placeholder]="tt('common_search_product_name', '輸入產品名稱')">
        <button class="col-auto ml-2 btn" nbButton (click)="onQuery()">
          <i class="fas fa-search"></i>
        </button>
      </div>

      <div class="d-flex mx-0 mt-2 justify-content-between">
        <nb-select class="col-auto pr-0 ml-auto" style="width:180px" [(ngModel)]="selectORG_Store_ID" (selectedChange)="onQuery()">
          <nb-option *ngFor="let e of storeSelectList" [value]="e.value">{{ e.content }}</nb-option>
        </nb-select>
      </div>

      <div class="mt-3">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ tt('common_type_name', '種類名稱') }}</th>
              <th>{{ tt('common_create_store_action', '建立門市') }}</th>
              <th>{{ tt('common_enable', '啟用') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="mainDataList && mainDataList.length">
              <td><b class="text-info">{{ tt('common_select_all', '全選') }}</b></td>
              <td></td>
              <td>
                <nb-toggle status="info" [(checked)]="status.isSelectAll" (checkedChange)="onSelectAllG()"></nb-toggle>
              </td>
              <td>
                <b class="text-info">{{ tt('common_selected_count', '已選') }}{{status.AllSelectCount}}{{ tt('common_item_unit', '項') }}</b>
              </td>
            </tr>
            <ng-container *ngFor="let e of mainDataList">
              <tr>
                <td>{{ e.GroupName }}</td>
                <td style="vertical-align: middle;">{{ e.CreateStoreName }}</td>
                <td>
                  <nb-toggle status="info" [(checked)]="e.IsOK_Group" (checkedChange)="onSelectG(e.GroupNo)"></nb-toggle>
                </td>
                <td>
                  <button nbButton class="m-0 col-sm-12" (click)="onOpenPd(e.GroupNo)">
                    {{ e.CountStr ? e.CountStr : tt('common_select', '選擇') }}
                  </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="onSavePdG();">{{ tt('common_confirm', '確定') }}</button>
      <button nbButton (click)="ref.close()">{{ tt('common_cancel', '取消') }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #PdModal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate">
    <nb-card-header>
      {{ tt('product_add_product', '選擇商品') }}
    </nb-card-header>
    <nb-card-body class="staffInfoTemplate">
      <div class="mt-3">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ tt('common_create_store_action', '建立門市') }}</th>
              <th>{{ tt('common_product_name', '商品名稱') }}</th>
              <th>{{ tt('common_original_price', '原價') }}</th>
              <th>{{ tt('common_enable', '啟用') }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let e of showListPd">
              <tr>
                <td style="vertical-align: middle;">{{ e.CreateStoreName }}</td>
                <td>{{ e.Name }}</td>
                <td>{{ e.Cash }}</td>
                <td>
                  <nb-toggle status="info" [(checked)]="e.IsOK_Product" [disabled]="e.IsCanSelect == 0"></nb-toggle>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="onSavePd();">{{ tt('common_confirm', '確定') }}</button>
      <button nbButton (click)="ref.close()">{{ tt('common_cancel', '取消') }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
